// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C8fDs","placeholdersHeader":"styles_placeholdersHeader__25bGf","editorStyle":"styles_editorStyle__1WVY_","placeholdersBox":"styles_placeholdersBox__134zY"};